module.exports = __webpack_public_path__ + "static/media/product_img_default.a09d1a8f.png";